<template>
<div class="overflow-xh paddingh10">
	<div class="clearfix marginr-n10">
		<slot></slot>
	</div>
</div>
</template>

<script>
import maple from 'maple';
export default {
	props: {
		data: {
			type: Array
			, default: []
		}
		, cols: {
			type: Number
			, default: 2
		}
		, space: {
			type: Number
		}
		, imgPath: {
			type: String
		}
	}
	, data: function(){
		var colList = []
			, colHeight = []
			, urlList = this.data.map(d=>d[this.imgPath])
			, i
			;

		for(i = 0; i < this.cols; i++){
			colHeight.push(0);
			colList.push([]);
		}



//		urlList.length && maple.load({
//			type: 'img'
//			, url: this.data.map(d=>d[this.imgPath])
//			, success: imgList=>{
//				imgList = Array.isArray( imgList ) ? imgList : [imgList];
		this.data.forEach((d, i)=>{
//				imgList.forEach((d, i)=>{
					var min = Math.min.apply(null, colHeight)
						, index = colHeight.indexOf( min )
						, h = colHeight[index]
						;

					colHeight.splice(index, 1, h + (d && d.width ? d.height/d.width: 1));
					colList[index].push( this.data[i] );
//				});
//			}
		});

		this.$root.$set('waterfallRealData', colList);

		return {
			length: this.data.length
			, colHeight: colHeight
			, colList: colList
		};
	}
	, watch: {
		data: function(newVal){
			var newLength = newVal.length - this.length
				;

			if( newLength > 0 ){
//				maple.load({
//					type: 'img'
//					, url: newVal.slice(this.length).map(d=>d[this.imgPath])
//					, success: imgList=>{
//						imgList = Array.isArray( imgList ) ? imgList : [imgList];
				newVal.slice(this.length).forEach((d, i)=>{
//						imgList.forEach((d, i)=>{
							var min = Math.min.apply(null, this.colHeight)
									, index = this.colHeight.indexOf( min )
									, h = this.colHeight[index]
									;

							this.colHeight.splice(index, 1, h + (d && d.width ? d.height/d.width: 1));
							this.colList[index].push( newVal[this.length + i] );

//							if( !d ){
//								newVal[this.length + i][this.imgPath] = '//image1.51tiangou.com/tgou2/img2/fitting/defaultFittingListPic.png';
//							}
						});

						this.length = newVal.length;
//console.log(this.colList)
						this.$root.$set('waterfallRealData', this.colList);
						this.$dispatch('waterfallReady');
//					}
//				});
			}
			else{
				this.length = 0;
				this.colHeight = [];
				this.colList = [];
				for(var i = 0; i < this.cols; i++){
					this.colHeight.push(0);
					this.colList.push([]);
				}
			}
		}
	}
};
</script>

<style lang="scss">

</style>